module.exports = __webpack_public_path__ + "img/car100.185505a6.png";